///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, kioskRacksRequestActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getKioskRacksRequest = function* ({ payload }) {
	const user = yield select(selectIdsUser)

	const apiCall = R.GET_KIOSK_RACKS_REQUEST(payload.idKioskProduction)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(kioskRacksRequestActionCreators.getKioskRacksRequestSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskRacksRequestActionCreators.getKioskRacksRequestFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getKioskRacksRequestForm = function* () {
	const user = yield select(selectIdsUser)

	const apiCall = R.GET_KIOSK_RACKS_REQUEST_FORM()
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(kioskRacksRequestActionCreators.getKioskRacksRequestFormSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskRacksRequestActionCreators.getKioskRacksRequestFormFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postKioskRacksRequestAddRack = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_KIOSK_RACKS_REQUEST_ADD_RACK(payload.idKioskProduction)
	const MsgParams = 'toast__rackUpdate__addRack'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.data)

		yield put(kioskRacksRequestActionCreators.postKioskRacksRequestAddRackSuccess(data.data))
		//yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskRacksRequestActionCreators.postKioskRacksRequestAddRackFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postKioskRacksRequestUpdateRack = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_KIOSK_RACKS_REQUEST_UPDATE_RACK(payload.idRack)
	const MsgParams = 'toast__rackUpdate__updateRack'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.data)

		yield put(kioskRacksRequestActionCreators.postKioskRacksRequestUpdateRackSuccess(data.data))
		//yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskRacksRequestActionCreators.postKioskRacksRequestUpdateRackFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postKioskRacksRequestUpdateRequest = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST(payload.idRequest)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.data)

		yield put(kioskRacksRequestActionCreators.postKioskRacksRequestUpdateRequestSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskRacksRequestActionCreators.postKioskRacksRequestUpdateRequestFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const putKioskRacksRequestDeleteRequest = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST(payload.idRequest)
	const MsgParams = 'toast__rackUpdate__deleteRack'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(kioskRacksRequestActionCreators.putKioskRacksRequestDeleteRequestSuccess(data.data))
		//yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskRacksRequestActionCreators.putKioskRacksRequestDeleteRequestFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const putKioskRacksRequestDeleteRack = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_KIOSK_RACKS_REQUEST_DELETE_RACK(payload.idRack)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(kioskRacksRequestActionCreators.putKioskRacksRequestDeleteRackSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskRacksRequestActionCreators.putKioskRacksRequestDeleteRackFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_KIOSK_RACKS_REQUEST, getKioskRacksRequest)
	yield takeLatest(ActionsTypes.GET_KIOSK_RACKS_REQUEST_FORM, getKioskRacksRequestForm)
	yield takeLatest(ActionsTypes.POST_KIOSK_RACKS_REQUEST_ADD_RACK, postKioskRacksRequestAddRack)
	yield takeLatest(ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_RACK, postKioskRacksRequestUpdateRack)
	yield takeLatest(ActionsTypes.POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST, postKioskRacksRequestUpdateRequest)
	yield takeLatest(ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST, putKioskRacksRequestDeleteRequest)
	yield takeLatest(ActionsTypes.PUT_KIOSK_RACKS_REQUEST_DELETE_RACK, putKioskRacksRequestDeleteRack)
}

export default sagas
